import { inject } from 'vue';
import { ApiClient } from '@/ApiClient';

export const useApi = () => inject<InstanceType<typeof ApiClient>>('$api')!;

export const blobUrl = import.meta.env.VITE_BLOB_URL;
